import { EFlatStatsStatus } from '../../types/flatStats';
import { IApplicationState } from '../../types/redux';

export function selectCurrentMortgageRate(state: IApplicationState): number | null {
  const {
    fieldsState: { rooms },
    flatStats,
  } = state;

  if (flatStats.status !== EFlatStatsStatus.Succeed) {
    return null;
  }

  return flatStats.result[rooms].avgMortgageRate;
}
